import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import equitySecuritiesService from "@equitySecurityService";
import debtSecurityService from "@debtSecurityService";
import derivativeService from "@derivativeSecurityService";

export function useSecurityDetail(securityType: SecurityType | null, securityId: string | null) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['security-detail', securityType, securityId, user?.id],
    queryFn: async () => {
      if (!securityType || !securityId) throw new Error('Security type and ID are required');
      switch (securityType) {
        case 'equity':
          return await equitySecuritiesService.fetchEquitySecurityById({id: securityId, userId: user!.id});
        case "debt":
          return await debtSecurityService.fetchDebtSecurityById({id: securityId, userId: user!.id});
        case "derivative":
          return await derivativeService.fetchDerivativeSecurityById({id: securityId, userId: user!.id})
        default:
          throw new Error(`Unknown security type: ${securityType}`);
      }
    },
    staleTime: 86_400_000,
    gcTime: 86_400_000,
    enabled: !!user && !!securityType && !!securityId,
  });
}
